import type { ReactElement } from "react";

import type { LinkProps } from "react-router";

import { styled } from "simplydo/react/styled";

import { RenderButton } from "./Button";
import type { ButtonStyleProps } from "./Button.types";

export type ButtonLinkProps = ButtonStyleProps &
  Omit<
    LinkProps,
    "color" | "children" | "className" | "aria-disabled" | "tabIndex"
  >;

const ButtonLinkComponent = (props: ButtonLinkProps): ReactElement => (
  <RenderButton {...props} asLink />
);

export const ButtonLink = styled(ButtonLinkComponent)``;
